<template>
    <div ref="selectProject">
        <div @click="expand = !expand" class="button-select-project" v-ripple>
            <span class="ellipsis-nowrap">{{selectText}}</span>
            <i class="mi-keyboard-arrow-down ml-auto transition-all-0-5" :class="{'rotate-180': expand, 'top-0': !expand}"></i>

            <div v-show="expand" class="dropdown-projects custom-scroll" @click.stop>

                <div v-if="userProjects.length" class="search-projects m-2">
                    <input @focus="searchFocused = true"
                           @blur="searchFocused = false"
                           :style="searchFocused ? {'border-color': menuColor} : {}"
                           class="form-control form-control-sm"
                           v-model="search"
                           placeholder="Search"/>
                    <i v-show="!search" class="mi-search mi-1-2x icon-search-projects cursor-default"></i>
                    <i v-show="search" @click="search = ''" class="mi-close mi-1-2x icon-clear-search"></i>
                </div>

                <div v-if="bookmarkProjects.length" class="bookmark-projects pb-2" :class="{'border-0': !anotherProjects.length}">
                    <div v-for="bookmarkProject of bookmarkProjects"
                         :key="bookmarkProject.id"
                         v-ripple
                         @click="clickProject(bookmarkProject.id)"
                         class="item-project"
                         :style="linkStyleByMenuColor(bookmarkProject.id)">
                        <span class="ellipsis-nowrap pr-1">{{ bookmarkProject.title }}</span>
                        <i v-show="!spinnerByProject(bookmarkProject.id)" @click.stop.prevent="deleteProjectBookmark($event, bookmarkProject.id)"
                           class="mi-turned-in top-0 icon-bookmark-project active"></i>
                        <i v-show="spinnerByProject(bookmarkProject.id)" class="icon-spinner4 spinner font-size-xs line-height-xs mr-02"></i>
                    </div>
                </div>

                <div v-if="anotherProjects.length" class="another-projects mt-2 mb-2">
                    <div v-for="anotherProject of anotherProjects"
                         :key="anotherProject.id"
                         v-ripple
                         @click="clickProject(anotherProject.id)"
                         class="item-project"
                         :style="linkStyleByMenuColor(anotherProject.id)">
                        <span class="ellipsis-nowrap pr-1">{{ anotherProject.title }}</span>
                        <i v-show="!spinnerByProject(anotherProject.id)" @click.stop.prevent="createProjectBookmark($event, anotherProject.id)" class="mi-turned-in top-0 icon-bookmark-project"></i>
                        <i v-show="spinnerByProject(anotherProject.id)" class="icon-spinner4 spinner font-size-xs line-height-xs mr-02"></i>
                    </div>
                </div>

                <div v-if="!bookmarkProjects.length && !anotherProjects.length" class="m-2">
                    <span v-if="userProjects.length" class="text-999">No project found</span>
                    <span v-else class="text-999">No projects in the account</span>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import EventBus, {MAIN_WINDOW_CLICK} from "@/utils/event-bus";
import {mapGetters, mapState} from "vuex";
import {CREATE_PROJECT_BOOKMARK, DELETE_PROJECT_BOOKMARK} from "@/store/sidebar/actions";
import {UpdateAccountProperty} from "@/utils/session-storage";

export default {
    name: 'SelectProjectSidebar',
    methods: {
        initParentRipple(event) {
            event.target.parentElement.dispatchEvent(new Event('init-ripple'));
        },
        removeFromSpinnerProjectIds(projectId) {
            let index = this.spinnerProjectIds.indexOf(projectId);
            if (index !== -1) {
                this.spinnerProjectIds.splice(index, 1);
            }
        },
        onWindowClick(event) {
            if (
                this.$refs.selectProject
                && this.$refs.selectProject !== event.target
                && this.$refs.selectProject !== event.target
                && !this.$refs.selectProject.contains(event.target)
            ) {
                this.expand = false;
            }
        },
        clickProject(projectId) {
            UpdateAccountProperty(this.accountName, 'lastSelectedProjectId', projectId);
            this.expand = false;
            window.location.href = this.projectId && window.projectID && !this.path.includes(`${this.projectId}/edit/`) ?
                `/${this.path.replace(this.projectId, projectId)}` :
                `/project/${projectId}/content-items`;
        },
        deleteProjectBookmark(event, projectId) {
            this.initParentRipple(event);
            let bookmarkId = this.userProjectsByBookmarkId?.[projectId] ?? undefined;
            if (!bookmarkId) {
                return;
            }
            this.spinnerProjectIds.push(projectId);
            this.$store.dispatch(DELETE_PROJECT_BOOKMARK, bookmarkId).then(() => {
                let project = this.userProjects.find(project => project.id === projectId);
                this.anotherProjects.push(project);
                this.bookmarkProjects = this.bookmarkProjects.filter(project => project.id !== projectId);
                delete this.userProjectsByBookmarkId[projectId];
                this.removeFromSpinnerProjectIds(projectId);
            });
        },
        createProjectBookmark(event, projectId) {
            this.initParentRipple(event);
            this.spinnerProjectIds.push(projectId);
            this.$store.dispatch(CREATE_PROJECT_BOOKMARK, projectId).then(res => {
                let project = this.userProjects.find(project => project.id === projectId);
                this.bookmarkProjects.push(project);
                this.anotherProjects = this.anotherProjects.filter(project => project.id !== projectId);
                this.userProjectsByBookmarkId[projectId] = res.data.id;
                this.removeFromSpinnerProjectIds(projectId);
            });
        },
    },
    computed: {
        ...mapGetters(['linkStyleByMenuColor']),
        ...mapState({
            userProjects: state => state.sidebar.userProjects,
            userProjectsByBookmarkId: state => state.sidebar.userProjectsByBookmarkId,
            menuColor: state => state.sidebar.menuColor,
            projectName: state => state.sidebar.projectName,
            projectId: state => state.sidebar.projectId,
            path: state => state.sidebar.path,
            accountName: state => state.sidebar.accountName,
        }),
        spinnerByProject() {
            return projectId => this.spinnerProjectIds.includes(projectId);
        }
    },
    watch: {
        userProjects: {
            handler(v) {
                const bookmarkProjectIds = Object.keys(this.userProjectsByBookmarkId).map(Number);
                this.bookmarkProjects = v.filter(project => bookmarkProjectIds.includes(project.id));
                this.anotherProjects = v.filter(project => !bookmarkProjectIds.includes(project.id));
            },
            immediate: true
        },
        search(v) {
            v = v.toLowerCase().trim();
            const bookmarkProjectIds = Object.keys(this.userProjectsByBookmarkId).map(Number);
            this.bookmarkProjects = this.userProjects.filter(project => bookmarkProjectIds.includes(project.id) && (!v || project.title.toLowerCase().includes(v)));
            this.anotherProjects = this.userProjects.filter(project => !bookmarkProjectIds.includes(project.id) && (!v || project.title.toLowerCase().includes(v)));
        },
        projectName: {
            handler(v) {
                this.selectText = v ? v : 'Select project';
            },
            immediate: true
        }
    },
    mounted() {
        EventBus.on(MAIN_WINDOW_CLICK, this.onWindowClick);
    },
    destroyed() {
        EventBus.off(MAIN_WINDOW_CLICK, this.onWindowClick);
    },
    data() {
        return {
            selectText: 'Select project',
            spinnerProjectIds: [],
            bookmarkProjects: [],
            anotherProjects: [],
            search: '',
            expand: false,
            searchFocused: false
        }
    }
}
</script>
